export const SET_ALL_CAMPAIGNS = 'SET_ALL_CAMPAIGNS';
export const SET_CAMPAIGN_FROMJSON = 'SET_CAMPAIGN_FROMJSON';
export const SET_CAMPAIGN = 'SET_CAMPAIGN';
export const REMOVE_CAMPAIGN = 'REMOVE_CAMPAIGN';
export const UPDATE_CAMPAIGN_FROMJSON = 'UPDATE_CAMPAIGN_FROMJSON';
